module.exports = __webpack_public_path__ + "img/miniCode.4417657b.png";